import { Box, Button, Dialog, Fab, Grid, Modal } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { dateWithTime, getUserNameById, styleInternalMessageModal } from '../config'
import { useAuth, useUsersContext } from '../context'

const ReportMessagesDialog = ({ open, close, report }) => {
    const { userData } = useAuth()
    const { usersMap } = useUsersContext()
    const [messages, setMessages] = useState([])

    useEffect(() => {
        const fetchNamesAndDetails = async () => {
            if (!report || !report.history) return

            const historyWithDetails = await Promise.all(report.history.map(async (message) => {
                let userId = message.userSendingData
                if (userId && typeof userId === 'object' && userId.$oid) {
                    userId = userId.$oid
                }

                const userInMap = userId ? usersMap[userId] : null

                let name = message.userName || message.name || (userInMap ? `${userInMap.name} ${userInMap.lastName}` : 'Desconocido')
                const userRole = userInMap?.role?.dbName || 'unknown'

                if (name === 'Desconocido' && userId && userId !== 'null' && navigator.onLine) {
                    try {
                        const fetchedName = await getUserNameById(userId)
                        if (fetchedName && fetchedName !== 'Sin información' && fetchedName !== 'Test Name') {
                            name = fetchedName
                        }
                    } catch (e) {
                        console.error('Error fetching name for history item', e)
                    }
                }

                let statusText = 'Mensaje'
                let statusColor = '#1976D2'
                let backgroundColor = '#E3F2FD'

                if (message.type) {
                    switch (message.type) {
                    case 'reject-for-end-day':
                    case 'rechazo-etapa':
                    case 'reject-to-previous-level':
                        statusText = 'Rechazado'
                        statusColor = '#D32F2F'
                        backgroundColor = '#FFEBEE'
                        break
                    case 'sending-to-next-level':
                    case 'avance-etapa':
                    case 'aprobacion-supervisor':
                    case 'aprobacion-jefe-maquinaria':
                    case 'aprobado-sap':
                    case 'cierre-completo':
                        statusText = 'Enviado'
                        statusColor = '#388E3C'
                        backgroundColor = '#E8F5E9'
                        break
                    case 'cierre-jornada':
                        statusText = 'Jornada Finalizada'
                        statusColor = '#F57C00'
                        backgroundColor = '#FFF3E0'
                        break
                    default:
                        statusText = 'Mensaje'
                        statusColor = '#1976D2'
                        backgroundColor = '#E3F2FD'
                    }
                }

                return { ...message, name, userRole, statusText, statusColor, backgroundColor }
            }))

            setMessages(historyWithDetails.sort((a, b) => b.id - a.id))
        }

        fetchNamesAndDetails()
    }, [report, usersMap])

    console.log('Messages with details:', messages)

    return (
        <Dialog
            open={open}
            onClose={close}
            maxWidth={'xl'}
            adaptiveHeight={true}
        >
            <div style={{ width: 800, padding: 10 }} >
                <h1>Mensajes a las revisiones de la OT</h1>
                <div style={{ width: '100%', overflowY: 'auto', height: 'calc(100vh - 300px)' }}>
                    {
                        (messages.length === 0) && <p>No hay mensajes</p>
                    }
                    {
                        (messages.length > 0) && messages.map((message, index) => {
                            return (
                                <div key={index} style={{ width: '100%', padding: 10 }}>
                                    <div style={{ borderRadius: 20, backgroundColor: message.backgroundColor, padding: 10 }}>
                                        <p style={{ fontSize: 14, color: message.statusColor, marginBottom: 5 }}>
                                            <strong>{message.statusText}</strong>
                                        </p>
                                        <p style={{ fontSize: 16, color: '#333', marginBottom: 5 }}>
                                            <strong>{message.name}</strong>
                                        </p>
                                        <p style={{ fontSize: 18, color: '#333', marginBottom: 5 }}>{message.message}</p>
                                        <p style={{ fontSize: 11, color: '#666', textAlign: 'right', marginTop: 10 }}>Fecha: {dateWithTime(message.id)}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <Fab onClick={() => close()} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
            </div>
        </Dialog>
    )
}

export default ReportMessagesDialog
